var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg512(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reverse",
    transform: "translate(0.991675, 1.000000)",
    fillRule: "evenodd",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "base",
    stroke: "#687577",
    fill: "#FFFFFF",
    d: "M11.604697,29.6352 C10.8897157,29.6352 8.71502404,29.5273479 7.82363222,29.2720176 C7.76574531,29.2552145 7.71011189,29.2314962 7.65794472,29.2013797 C4.66484676,27.457484 1.01107423,24.8518055 0.598412049,22.337784 C0.0273263306,20.0074211 -2.80664381e-13,18.0939944 -2.80664381e-13,14.6396268 C-2.80664381e-13,5.70065402 7.14946743,3.10862447e-13 10.8879862,3.10862447e-13 C14.6199328,3.10862447e-13 20.3857885,5.8433082 20.5732679,14.6506533 L20.5732679,14.6506533 C20.7527915,23.1179025 20.4809118,26.6711631 11.8392192,29.5966076 C11.7636647,29.6220615 11.6844552,29.6352 11.604697,29.6352 Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hookstyle",
    transform: "scale(-1, 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hook",
    fill: "none",
    transform: "translate(-8.000000, -10.000000)",
    d: "M3.58716581,4.86252597 C3.06706263,4.62380711 2.85229747,4.03585383 3.10747439,3.54929557 C3.36265132,3.06273731 3.99114002,2.86182379 4.5112432,3.10054265 C5.46056455,3.53626565 6.39450266,4.14450585 7.31484578,4.922185 C8.2443698,5.70762188 10.0438875,7.8539425 12.8028208,11.4459993 C13.1408693,11.8861293 13.0335172,12.4992928 12.5630432,12.8155382 C12.0925692,13.1317837 11.4371322,13.0313555 11.0990837,12.5912255 C8.44101017,9.13048544 6.68104531,7.03134029 5.90861111,6.37864246 C5.12699602,5.71818688 4.35258484,5.21384081 3.58716581,4.86252597 Z"
  }))), /*#__PURE__*/React.createElement("line", {
    x1: 4.008325,
    y1: 5.5,
    x2: 17.008325,
    y2: 25.5,
    id: "extracted",
    stroke: "none",
    strokeLinecap: "square"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg512);
export default __webpack_public_path__ + "static/media/5-12.8758899ab94e3594979452ed2499b134.svg";
export { ForwardRef as ReactComponent };